import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ShopPage } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'shop',
    events: {
        'Load Dealer Shop': emptyProps(),
        'Load Dealer Shop Success': props<{ shop: ShopPage }>(),
        'Load Dealer Shop Failure': props<{ error: string }>(),
    },
});
